import { Link } from 'gatsby';
import React from 'react';
import * as ArchiveStyles from './Archive.module.scss'

const ConditionalLink = ({ linkType, uri, children, className }: any) => {
  if (linkType === 'external') {
    return (
      <a href={uri} className={className}>
        {children}
      </a>
    )
  }

  return (
    <Link to={uri} className={className}>
      {children}
    </Link>
  )
}

const ArchiveBlock = ({post} : any) => {
    return (
        <div className={ArchiveStyles.Block} key={post.id}>
          {post.homepagePreviewImage && (
            <ConditionalLink
              uri={post.uri ?? ''}
              linkType={post.linkType}
              className={ArchiveStyles.Block_Img}
            >
              {post.homepagePreviewImage && (
                <img src={post.homepagePreviewImage ?? ''} alt={''} />
              )}
            </ConditionalLink>
          )}
          {post.featuredImage && (
            <ConditionalLink
              uri={post.uri ?? ''}
              linkType={post.linkType}
              className={ArchiveStyles.Block_Img}
            >
              {post.featuredImage && (
                <img
                  src={post.featuredImage.node.sourceUrl ?? ''}
                  alt={''}
                />
              )}
            </ConditionalLink>
          )}
          <div className={ArchiveStyles.Block_Text}>
            <ConditionalLink
              uri={post.uri ?? ''}
              linkType={post.linkType}
            >
              {post.title}
            </ConditionalLink>
          </div>
        </div>
    )
}

export default ArchiveBlock;